import { isNumber, toNumber } from "@foretagsplatsen/core-helpers/number";
import Model from "../../Model.js";

/**
 * InvoiceCode encapsulates the behavior of codes in invoices, with regard to
 * OCR, sorting, and displaying a label.
 *
 * @param {string} [spec.code] - Raw invoice identifier.
 * @param {string} [spec.ocr] - OCR identifier of the invoice.
 */
export default class InvoiceCode extends Model {
	constructor({ code = "", ocr }) {
		super(...arguments);

		this._code = code;
		this._ocr = ocr;
	}

	getCode() {
		return this._code;
	}

	getOCR() {
		return this._ocr;
	}

	getLabel() {
		if (this.getOCR()) {
			return `ocr:${this.getOCR()}`;
		}
		return this.getCode();
	}

	compareTo(invoiceCode) {
		if (this._isCodeNumerical()) {
			return invoiceCode.compareToNumericalCode(this);
		}

		return this.compareLexicographicalCode(invoiceCode);
	}

	compareToNumericalCode(invoiceCode) {
		if (this._isCodeNumerical()) {
			return invoiceCode.compareNumericalCode(this);
		}

		return invoiceCode.compareLexicographicalCode(this);
	}

	compareNumericalCode(otherInvoice) {
		return this.toNumber() <= otherInvoice.toNumber();
	}

	compareLexicographicalCode(otherInvoice) {
		return this.getLabel() <= otherInvoice.getLabel();
	}

	toNumber() {
		return toNumber(this.getLabel());
	}

	_isCodeNumerical() {
		return isNumber(this.toNumber());
	}
}
